import { FilterSelect } from './FilterSelect';
import type { SelectOption } from './selectTypes';

type Props = {
  keyOptions: SelectOption[];
  searchKey: string;
  searchValue: string;
  onKeyChange: (key: string) => void;
  onValueChange: (value: string) => void;
};

/** "Search by <key>" select + text input (legacy SearchBox). */
export const SearchKeyInput = ({
  keyOptions,
  searchKey,
  searchValue,
  onKeyChange,
  onValueChange,
}: Props) => (
  <>
    <FilterSelect options={keyOptions} value={searchKey} onChange={onKeyChange} />
    <input
      className="form-control input-sm"
      style={{ marginTop: 6, width: 250 }}
      placeholder="Поиск..."
      value={searchValue}
      onChange={(e) => onValueChange(e.target.value)}
    />
  </>
);
